import React, { useState } from "react";
import { getExpectedDate } from "../utils";
import PickupModal from "./PickupModal";
import Button from "./Button";
import ConfirmBoxModal from "./ConfirmBoxModal";
import {
  useChangePickupOrderMutation,
  useDeclareOrderMutation,
  useDeleteOrderMutation,
} from "../store/api/orderApi";
import { useNavigate } from "react-router";
import DeliveryModal from "./DeliveryModal";
import { FaRegTrashAlt } from "react-icons/fa";

const OrderCard = ({ order, onClick }) => {
  const [openPayment, setOpenPayment] = useState(false);
  const [openDeliveryModal, setOpenDeliveryModal] = useState(false);
  const [orderData, setOrderData] = useState(order);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [openBoxConfirm, setOpenBoxConfirm] = useState(false);
  const [changePickupOrder] = useChangePickupOrderMutation();
  const [createOrEditOrder, { isLoading }] = useDeclareOrderMutation();
  const [deleteOrder] = useDeleteOrderMutation();
  const navigate = useNavigate();
  const handleDeleteOrder = async () => {
    try {
      await deleteOrder({ order_guid: order.guid }).unwrap();
      setOpenDeleteConfirm(false);
    } catch (err) {
      alert("Не удалось удалить заказ: " + (err?.data?.message || err.message));
    }
  };
  return (
    <>
      <PickupModal
        isOpen={openPayment}
        onClose={() => setOpenPayment(false)}
        handleSkip={() => setOpenPayment(false)}
        onAccept={(form) => {
          changePickupOrder({ ...form, guid: order.guid });
        }}
        value={order.pickup_guid}
        btnTitle={"Сохранить"}
        rejectTitle={"Отмена"}
        title="Изменить пункт выдачи заказа"
        description=""
      />
      {deleteSuccess && (
        <ConfirmBoxModal
          isOpen={deleteSuccess}
          onClose={() => setDeleteSuccess(false)}
          title="Удаление прошло успешно"
          description="Заказ успешно удалён."
          confirmLabel="Ок"
          hideCancel
        />
      )}
      <ConfirmBoxModal
        isOpen={openDeleteConfirm}
        onClose={() => setOpenDeleteConfirm(false)}
        onConfirm={handleDeleteOrder}
        title="Удаление заказа"
        description="Вы уверены, что хотите удалить этот заказ?"
        confirmLabel="Удалить"
        rejectLabel="Отмена"
      />
      <ConfirmBoxModal
        isOpen={openBoxConfirm}
        onClose={() => setOpenBoxConfirm(false)}
        onConfirm={() => {
          const newValue = !orderData.with_box;
          setOrderData({ ...orderData, with_box: newValue });
          createOrEditOrder({ ...orderData, with_box: newValue });
          setOpenBoxConfirm(false);
        }}
      />
      <DeliveryModal
        isOpen={openDeliveryModal}
        onClose={() => setOpenDeliveryModal(false)}
        handleSkip={() => setOpenDeliveryModal(false)}
        onAccept={(form) => {
          changePickupOrder({ ...form, guid: order.guid });
        }}
        value={order.pickup_guid}
        btnTitle={"Сохранить"}
        rejectTitle={"Отмена"}
        title="Доставка и адрес"
        description=""
      />

      <div className="order-card" onClick={() => onClick(order)}>
        <div className="order-card_header">
          <div className="order-card_num">№ {order.tracking_number}</div>

          <div className="order-card_status">
            {(Math.ceil((order.gross_weight ?? 0) * 10) / 10).toFixed(1)} кг
          </div>
        </div>

        <div className="order-card_country">
          <div className="order-card_country_from">
            <div className="order-card_country_flag">
              <img
                src={"https://onza-api.ibm.kg" + order.flag}
                alt="flag"
                className="order-flag"
              />
            </div>
            <div className="order-card_country_text">
              <div className="order-card_country_title">{order.country}</div>
              <div className="order-card_country_date">{!!(order.status == 16 || order.status == 29) && new Date(order.date_transfer).toLocaleDateString("ru-RU")}</div>
              <div className="order-card_country_date">{!!(order.status == 15) && new Date(order.date_accept).toLocaleDateString("ru-RU")}</div>

            </div>
          </div>
          <div className="order-card_country_to">
            <div className="order-card_country_text">
              <div className="order-card_country_title">Кыргызстан</div>
              {!!(order.status == 16) && <div className="order-card_country_date">
                Ожидается:
                {(
                  order.date_transfer
                ) ? order.country_guid === "A4D9A734-CCEC-49AF-A5B5-6D5765639D21" ? getExpectedDate(order.date_transfer, 8) : getExpectedDate(order.date_transfer, 9) : ""}
              </div>}
              <div className="order-card_country_date">{!!(order.status == 29) && getExpectedDate(order.updated_at, 0)}</div>
            </div>
            <div className="order-card_country_flag">
              <img
                src={"https://onza-api.ibm.kg/files/flags/Flag_of_Russia.png"}
                alt="flag"
                className="order-flag"
              />
            </div>
          </div>
        </div>

        <div className="order-card_footer">
          <div className="order-card_reciever">
            <div className="order-card_reciever_title"></div>
            {order.status == 29 && <div className="order-card_reciever_title">
              Стоимость <span> </span>
              <strong>
                {
                  (order.shipping_cost > 0) ? order.shipping_cost : (
                    Math.ceil((order.gross_weight ?? 0) * 10) / 10 *
                    (
                      order.country_guid === "9B785514-12A9-4336-A927-C36A46596D3D"
                        ? 990
                        : order.country_guid === "A4D9A734-CCEC-49AF-A5B5-6D5765639D21"
                          ? 1100
                          : 0
                    )
                  ).toLocaleString()}
              </strong>
              сом
            </div>}
          </div>
        </div>
        {order.delivery_address ? (
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              fontSize: 18,
            }}
          >
            {order.delivery_address}
          </label>
        ) : (
          ""
        )}
        {order.status || order.status == 25 ? (
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              fontSize: 18,
            }}
          >
            {order.pickup_name ?? order.prefer_pickup}
          </label>
        ) : (
          ""
        )}
        {!order.status || order.status == 25 ? (
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              fontSize: 18,
            }}
          >
            <input
              type="checkbox"
              checked={orderData?.with_box}
              style={{
                width: 18,
                height: 18,
                margin: "12px 0",
              }}
              onChange={(e) => {
                setOpenBoxConfirm(true); // вместо createOrEditOrder
              }}
            />
            Брендовая коробка от одежды/сумки/обуви нужна
          </label>
        ) : (
          ""
        )}
        {((order.status == 18 || order.status == 24) && order?.address_delivery) ? (
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              fontSize: 18,
            }}
          >

            Адрес доставки: {
              order?.address_delivery
            }
          </label>
        ) : (
          ""
        )}

        <div style={{ display: "flex", gap: 12 }}>
          {(order.status == 16 || order.status == 15) && (
            <Button
              style={{ height: 36, padding: "1px 2rem", margin: 0 }}
              onClick={() => setOpenPayment(true)}
            >
              Изменить ПВЗ
            </Button>
          )}
          {order.status === 0 && (
            <Button
              style={{ height: 36, padding: "1px 2rem", margin: 0 }}
              onClick={() => setOpenDeleteConfirm(true)}
              className="danger"
            >
              <FaRegTrashAlt />
            </Button>
          )}

          {((order.status == 16 || order.status == 15) && !order.amount) ||
            !order.category_guid ||
            !order.invoice_path ||
            !order.currency_guid ? (
            <>
              <Button
                style={{ height: 36, padding: "1px 2rem", margin: 0 }}
                onClick={() => {
                  navigate("/declare-order", {
                    state: order,
                  });
                }}
                className="success"
              >
                Задекларировать
              </Button>
            </>
          ) : ""}
        </div>
      </div>
    </>
  );
};

export default OrderCard;
